module.exports = __webpack_public_path__ + "top-desktop-banner-image.d5243d2da817c5d83bffd5ab6345768e.png";